import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function DollarConvert({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M11.7499 6.99999V8.24999M11.7499 17V15.75M14.2299 9.99999C14.1599 9.01999 13.3599 8.24999 12.3679 8.24999H10.9979C10.0279 8.24999 9.23793 9.02999 9.23793 9.99999C9.23793 10.8 9.78593 11.5 10.5579 11.7L12.9009 12.28C13.6809 12.47 14.2209 13.17 14.2209 13.98C14.2209 14.95 13.4309 15.73 12.4609 15.73H11.0909C10.0909 15.73 9.29093 14.95 9.22093 13.97M5.86993 5.86999C7.43893 4.30099 9.60693 3.32999 11.9999 3.32999C16.7799 3.32999 20.6719 7.20999 20.6719 11.998C20.6719 12.658 20.5819 13.308 20.4419 13.938M19.0999 12.602L20.6599 14.162L22.2199 12.592M18.1299 18.128C16.5599 19.688 14.3899 20.658 11.9899 20.658C7.19993 20.658 3.31793 16.768 3.31793 11.99C3.31793 11.32 3.39793 10.67 3.53793 10.04M4.89293 11.398L3.32293 9.82799L1.75293 11.388" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default DollarConvert;